import Pagination from "components/CustomWidgets/pagination";
import ListCards from "components/Explore/components/ListCards";
import OverViewCarousal from "components/CustomWidgets/overViewCarousal";
import { useWeddingStore } from "hooks/api/useWedding";
import JewelryBannerCard from "components/Cards/jewelryBannerCard";
import useMediaQuery from "hooks/useMediaQuery";
import FilterTags from "components/Explore/components/FilterTags";

function RightSection({
  data = [],
  current,
  setCurrent,
  count,
  searchText,
  search_type,
}) {
  const transformedData = data?.map((item) => ({
    aec_id: item?.aec_id,
    id: item.id,
    profileImage: item.profile_image,
    imageCount: item.image_count,
    profileName: item.name,
    profileAge: item.age,
    profileHeight: item.height,
    profileOcc: item.profession,
    verificationType: item.verification_type,
    isShow: !item.allow_image_view,
    isLike: item.has_expressed_interest,
    isFav: item.has_favorited,
    isPremium: item.is_premium_member,
    isSuggest: false,
    profileId: item.aec_id,
    lastSeen: item.last_seen,
    religion: item.religion,
    maritalStatus: item.marital_status,
    livesIn: item.lives_in,
    primaryLanguage: item.primary_language,
    createdBy: item.created_by,
    image_request: item?.image_requested,
    isPrivate: item?.is_private,
  }));

  const firstHalf = transformedData.slice(0, 8);
  const secondHalf = transformedData.slice(8);
  const isMobile = useMediaQuery("(max-width: 820px)");

  const { data: storeData, isLoading: isWeddingLoading } = useWeddingStore();

  return (
    <div className="right-section">
      <div className="list-container">
        <span>{count?.count}</span> search result found
        {searchText ? (
          <>
            {" "}
            for <span>{`"${searchText}"`}</span>
          </>
        ) : null}
      </div>
      {search_type === 2 && <FilterTags />}

      <div className="flex flex-col gap-8 mb-10">
        <ListCards firstHalf={firstHalf} secondHalf={secondHalf} isListing />
        <Pagination
          total={count?.count}
          currentPageNo={current}
          onChange={(page) => setCurrent(page)}
          pageSize={count?.limit}
          removeQuickJumber={isMobile}
        />
      </div>

      <OverViewCarousal
        isLoading={isWeddingLoading}
        carousalClass="store-carousal"
        cardTitle="Wedding store"
        cardDesc="Sponsored"
        seeAllBtn
        slidesToShow={2}
        carousalData={storeData}
        href="/wedding-store"
        renderItem={(item, i) => <JewelryBannerCard key={i} data={item} />}
        carousalResponsive={[
          {
            breakpoint: 1420,
            settings: {
              slidesToShow: 1.8,
            },
          },
          {
            breakpoint: 1050,
            settings: {
              slidesToShow: 1.5,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 1.2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1.5,
            },
          },
          {
            breakpoint: 450,
            settings: {
              slidesToShow: 1.2,
            },
          },
        ]}
      />
    </div>
  );
}

export default RightSection;
